import React, { useState, useEffect } from "react";
import { Form, Input, Button, Icon, Select } from "antd";
import Axios from "axios";
import { baseUrl } from "../../config";
const { Option } = Select;

const FormOriginal = props => {
  const [id, setId] = useState(0);
  const [components, setComponents] = useState([]);
  const [selectedComponents, setSelectedComponents] = useState([]);
  useEffect(() => {
    if (props.defaultValues) {
      setId(props.defaultValues.components.length);
      setSelectedComponents(props.defaultValues.components);
    }
    Axios.get(baseUrl + "components")
      .then(response => {
        setComponents(response.data);
      })
      .catch(function(error) {});
  }, []);
  const remove = k => {
    const { form } = props;
    // can use data-binding to get
    const keys = form.getFieldValue("keys");
    // We need at least one passenger
    if (keys.length === 1) {
      return;
    }

    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    });
  };

  const add = () => {
    const { form } = props;
    // can use data-binding to get
    const values = [...selectedComponents, null];

    setId(id + 1);
    setSelectedComponents(values);
    const keys = form.getFieldValue("keys");
    const nextKeys = keys.concat(id);

    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys
    });
  };

  const { getFieldDecorator, getFieldValue } = props.form;

  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 16, offset: 7 }
    }
  };
  getFieldDecorator("keys", {
    initialValue: props.defaultValues
      ? props.defaultValues.components.map((comp, id) => id)
      : []
  });
  const keys = getFieldValue("keys");
  const formItems =
    keys &&
    keys.map((k, index) => (
      <Form.Item required={false} key={k}>
        {getFieldDecorator(`components[${k}]`, {
          validateTrigger: ["onChange", "onBlur"],
          initialValue:
            selectedComponents && selectedComponents[k]
              ? selectedComponents[k]._id
              : null,
          rules: [
            {
              required: true,
              message: "Please add component or delete this field."
            }
          ]
        })(
          <Select
            style={{ width: "calc(100% - 50px)", border: "0px !important" }}
          >
            {components &&
              components.map(comp => (
                <Option value={comp._id} key={comp._id}>
                  {comp.name} / {comp.label}
                </Option>
              ))}
          </Select>
        )}
        {keys.length > 1 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => remove(k)}
          />
        ) : null}
      </Form.Item>
    ));
  return (
    <div
      style={{
        width: "600px",
        margin: "0 auto",
        padding: "20px 20px 20px 20px",
        background: "#eee",
        borderWidth: "2px",
        borderRadius: "20px"
      }}
    >
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex"
        }}
      >
        <Form
          onSubmit={e => props.handleSubmit(e, props.form)}
          className="login-form"
          style={{ width: "100%" }}
        >
          <Form.Item label="Product Name">
            {getFieldDecorator("name", {
              initialValue: props.defaultValues && props.defaultValues.name,
              rules: [
                { required: true, message: "Please input your product name!" }
              ]
            })(<Input placeholder="name" className="antInput" />)}
          </Form.Item>
          <Form.Item label="Mac Address">
            {getFieldDecorator("macId", {
              initialValue: props.defaultValues && props.defaultValues.macId,

              rules: [
                {
                  required: true,
                  message: "Please input your product mac address!"
                }
              ]
            })(<Input placeholder="MacId" className="antInput" />)}
          </Form.Item>
          <Form.Item label="Banner Image">
            {getFieldDecorator("bannerImage", {
              initialValue:
                props.defaultValues && props.defaultValues.bannerImage,

              rules: [
                {
                  required: true,
                  message: "Please input your product banner Image!"
                }
              ]
            })(<Input placeholder="bannerImage" style={{ width: "100%" }} />)}
          </Form.Item>
          <Form.Item label="Company Image">
            {getFieldDecorator("companyLogo", {
              initialValue:
                props.defaultValues && props.defaultValues.companyLogo,

              rules: [
                {
                  required: true,
                  message: "Please input your product company logo!"
                }
              ]
            })(<Input placeholder="companyLogo" className="antInput" />)}
          </Form.Item>
          <p>Components:</p>

          {formItems}
          <Form.Item {...formItemLayoutWithOutLabel}>
            <Button type="dashed" onClick={add} style={{ width: "100%" }}>
              <Icon type="plus" /> Add field
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              {props.type} Product
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
const WrappedNormalLoginForm = Form.create({ name: "productCreate" })(
  FormOriginal
);

export default WrappedNormalLoginForm;
